import { render, staticRenderFns } from "./SearchMatching.vue?vue&type=template&id=546233da&scoped=true&"
import script from "./SearchMatching.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchMatching.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546233da",
  null
  
)

export default component.exports